import React, { useEffect, useState } from 'react';
import logo from '../../assets/images/logo.svg';
import playStore from '../../assets/images/playStore.svg';
// import appStore from '../../assets/images/appStore.svg';
import aquipago from '../../assets/images/aquipago.png';
import express from '../../assets/images/express.png';

import { useNavigate, useLocation } from "react-router-dom";
import { sendEvent } from '../../utils/firebase';
import { pageWard } from '../../utils/pageward';



function Finish() {

  useEffect(() => {
    setIsActive(true);
    setTimeout(() => {
      setIsHiden(true);
    }, 1000)
  }, []);


  const navigate = useNavigate();
  const state = useLocation();

  const [userData, setUserData] = useState({
    name: "",
    sex: ""
  });

  useEffect(() => {
    if (state.state) {
      setUserData({
        ...userData,
        name: state.state.name,
        sex:state.state.sex
      });
    }
  }, []);


  useEffect(() => {
    if (!pageWard("DONE")) {
      navigate('/')
      return;
    };
  }, []);
  useEffect(() => {
    sendEvent("FINALIZO_REGISTRO");
  }, []);

  const [isActive, setIsActive] = useState(false);
  const [hideTransition, setIsHiden] = useState(false);
  const [fade, setfade] = useState(false);


  return (
    <div className="dark:bg-bgDark h-full p-3 flex flex-col h-screen justify-between">
      <header className={fade? "w-full  p-10 fadeOut" : "w-full  p-10 fadeIn"} >
        <img src={logo} className="h-12 mx-auto" alt="Wally" />
      </header>
      <div className={hideTransition ? 'transitionContainer hide' : 'transitionContainer'}>
        <div className={isActive ? 'transition show' : 'transition'}>
          <div className="layer one"></div>
          <div className="layer two"></div>
          <div className="layer three"></div>
        </div>
      </div>
      <div className={fade? "container mb-auto max-w-md mx-auto fadeOut" : "container mb-auto max-w-md mx-auto fadeIn"} >
        <div className={hideTransition ? 'w-full mx-auto show' : 'w-full mx-auto'}>
          <h1 className="text-xl text-wallyGray text-center font-semibold dark:text-white">{userData.sex === "FEMALE" ? "¡BIENVENIDA" :"¡BIENVENIDO" } {userData.name}!</h1>
          <p className="text-gray-400 mt-2">Tu registro fue realizado con éxito, ya podés enviar o recibir tus giros Wally desde cualquier punto de Aquí Pago o Pago Express.</p>
          <div className="flex mt-10">
          <img src={aquipago} className="aquipago mx-auto mt-5" alt="Wally" />
          <img src={express} className="express mx-auto mt-5" alt="Wally" />
          </div>
        </div>

      </div>
      <div className={fade? "container mb-20  max-w-md mx-auto fadeOut" : "container mb-20  max-w-md mx-auto fadeIn"}>
        <p className='text-gray-500 text-sm mb-5 dark:text-gray-200'>Hacé todo desde tu celular con Wally tu billetera digital, descargá la App gratis desde:</p>
        <div className="relative text-center mt-5 col-2 w-full">
          <a href="https://play.google.com/store/apps/details?id=py.com.wally" target={"_BLACK"}>
            <button  className="text-white text-xl mr-3 socialBtn bg-black p-2 ">
              <img src={playStore} className="h-9 mx-auto" alt="Wally" />
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Finish;